export interface CategoryItem {
  name: string;
  nameEn: string;
  nameDe: string;
  url: string;
}

export const categories: CategoryItem[] = [
  { name: 'Shoes', nameEn: 'Shoes', nameDe: 'Schuhe', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', nameEn: 'Hoodies/Sweaters', nameDe: 'Hoodies/Pullover', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', nameEn: 'T-Shirts', nameDe: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', nameEn: 'Jackets', nameDe: 'Jacken', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', nameEn: 'Pants/Shorts', nameDe: 'Hosen/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', nameEn: 'Headwear', nameDe: 'Kopfbedeckung', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', nameEn: 'Sets', nameDe: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear/Underpants', nameEn: 'Underwear/Underpants', nameDe: 'Unterwäsche', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', nameEn: 'Jersey', nameDe: 'Trikots', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', nameEn: 'Accessories', nameDe: 'Accessoires', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', nameEn: 'Bags', nameDe: 'Taschen', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', nameEn: 'Belts', nameDe: 'Gürtel', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', nameEn: 'Perfumes', nameDe: 'Parfüms', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', nameEn: 'Other Stuff', nameDe: 'Sonstiges', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export interface GuideItem {
  key: string;
  title: string;
  titleEn: string;
  titleDe: string;
}

export const guides: GuideItem[] = [
  { key: 'review', title: 'CSSBuy Review', titleEn: 'CSSBuy Review', titleDe: 'CSSBuy Review' },
  { key: 'shipping', title: 'CSSBuy Shipping Cost', titleEn: 'CSSBuy Shipping Cost', titleDe: 'CSSBuy Versandkosten' },
  { key: 'warehouse', title: 'CSSBuy Warehouse', titleEn: 'CSSBuy Warehouse', titleDe: 'CSSBuy Lager' },
  { key: 'qc', title: 'CSSBuy QC Guide', titleEn: 'CSSBuy QC Guide', titleDe: 'CSSBuy QC Ratgeber' },
  { key: 'coupon', title: 'CSSBuy Coupon', titleEn: 'CSSBuy Coupon', titleDe: 'CSSBuy Gutschein' },
  { key: 'discount', title: 'CSSBuy Discount Code', titleEn: 'CSSBuy Discount Code', titleDe: 'CSSBuy Rabattcode' },
];

export interface FaqItem {
  question: string;
  questionEn: string;
  questionDe: string;
  answer: string;
  answerEn: string;
  answerDe: string;
}

export const faqItems: FaqItem[] = [
  {
    question: 'O que é CSSBuy Spreadsheet?',
    questionEn: 'What is CSSBuy Spreadsheet?',
    questionDe: 'Was ist CSSBuy Spreadsheet?',
    answer: 'O CSSBuy Spreadsheet é uma forma organizada de pesquisar produtos, links e informações relacionadas ao CSSBuy. Ele reúne categorias, guias e comparações em um só lugar para facilitar sua decisão de compra.',
    answerEn: 'The CSSBuy Spreadsheet is an organized way to research products, links and information related to CSSBuy. It brings together categories, guides and comparisons in one place to facilitate your purchase decision.',
    answerDe: 'Das CSSBuy Spreadsheet ist eine organisierte Möglichkeit, Produkte, Links und Informationen zu CSSBuy zu recherchieren. Es fasst Kategorien, Ratgeber und Vergleiche an einem Ort zusammen, um Ihre Kaufentscheidung zu erleichtern.',
  },
  {
    question: 'Como funciona o CSSBuy Spreadsheet?',
    questionEn: 'How does CSSBuy Spreadsheet work?',
    questionDe: 'Wie funktioniert CSSBuy Spreadsheet?',
    answer: 'Você navega pelas categorias, encontra produtos de interesse, verifica informações como descrição e preço, compara opções e segue os links para o site principal quando estiver pronto para comprar.',
    answerEn: 'You browse categories, find products of interest, check information such as description and price, compare options and follow links to the main website when you are ready to buy.',
    answerDe: 'Sie stöbern durch Kategorien, finden Produkte, die Sie interessieren, prüfen Informationen wie Beschreibung und Preis, vergleichen Optionen und folgen den Links zur Hauptwebsite, wenn Sie bereit sind zu kaufen.',
  },
  {
    question: 'O CSSBuy Spreadsheet é gratuito?',
    questionEn: 'Is CSSBuy Spreadsheet free?',
    questionDe: 'Ist CSSBuy Spreadsheet kostenlos?',
    answer: 'Sim, usar o CSSBuy Spreadsheet para pesquisar e explorar informações é gratuito. Você só paga quando realiza uma compra no site principal.',
    answerEn: 'Yes, using the CSSBuy Spreadsheet to research and explore information is free. You only pay when you make a purchase on the main website.',
    answerDe: 'Ja, die Nutzung des CSSBuy Spreadsheet zur Recherche und zum Erkunden von Informationen ist kostenlos. Sie zahlen nur, wenn Sie auf der Hauptwebsite einen Kauf tätigen.',
  },
  {
    question: 'Como encontro produtos no CSSBuy Spreadsheet?',
    questionEn: 'How do I find products on CSSBuy Spreadsheet?',
    questionDe: 'Wie finde ich Produkte im CSSBuy Spreadsheet?',
    answer: 'Use as categorias no menu superior ou os botões de categoria na página inicial. Cada categoria leva a uma lista de produtos relacionados no site principal.',
    answerEn: 'Use the categories in the top menu or the category buttons on the homepage. Each category leads to a list of related products on the main website.',
    answerDe: 'Verwenden Sie die Kategorien im oberen Menü oder die Kategorie-Buttons auf der Startseite. Jede Kategorie führt zu einer Liste verwandter Produkte auf der Hauptwebsite.',
  },
  {
    question: 'O que é CSSBuy QC?',
    questionEn: 'What is CSSBuy QC?',
    questionDe: 'Was ist CSSBuy QC?',
    answer: 'QC (Quality Check) é o processo de verificação de qualidade onde fotos e inspeções do produto são realizadas antes do envio. Isso ajuda a confirmar que o item corresponde ao esperado.',
    answerEn: 'QC (Quality Check) is the quality verification process where photos and inspections of the product are performed before shipping. This helps confirm that the item matches expectations.',
    answerDe: 'QC (Quality Check) ist der Qualitätsprüfprozess, bei dem Fotos und Inspektionen des Produkts vor dem Versand durchgeführt werden. Dies hilft zu bestätigen, dass der Artikel den Erwartungen entspricht.',
  },
  {
    question: 'Como funciona o envio CSSBuy?',
    questionEn: 'How does CSSBuy shipping work?',
    questionDe: 'Wie funktioniert der CSSBuy Versand?',
    answer: 'O envio depende do peso, volume, destino e método escolhido. Recomendamos verificar as condições atuais diretamente no site antes de finalizar o pedido.',
    answerEn: 'Shipping depends on weight, volume, destination and chosen method. We recommend checking current conditions directly on the website before finalizing the order.',
    answerDe: 'Der Versand hängt vom Gewicht, Volumen, Zielort und der gewählten Methode ab. Wir empfehlen, die aktuellen Bedingungen direkt auf der Website vor Abschluss der Bestellung zu prüfen.',
  },
  {
    question: 'O CSSBuy é legítimo?',
    questionEn: 'Is CSSBuy legit?',
    questionDe: 'Ist CSSBuy legitim?',
    answer: 'Antes de usar qualquer serviço, verifique o domínio oficial, políticas, pagamentos e informações atualizadas. Este site é um recurso informativo independente.',
    answerEn: 'Before using any service, check the official domain, policies, payments and updated information. This website is an independent informational resource.',
    answerDe: 'Bevor Sie einen Dienst nutzen, prüfen Sie die offizielle Domain, Richtlinien, Zahlungen und aktualisierte Informationen. Diese Website ist eine unabhängige Informationsressource.',
  },
  {
    question: 'Como reduzir custos de envio?',
    questionEn: 'How to reduce shipping costs?',
    questionDe: 'Wie kann man Versandkosten reduzieren?',
    answer: 'Considere o peso real vs volumétrico, escolha métodos de envio mais econômicos, agrupe pedidos e verifique promoções atuais no site principal.',
    answerEn: 'Consider actual weight vs volumetric weight, choose more economical shipping methods, group orders and check current promotions on the main website.',
    answerDe: 'Berücksichtigen Sie das tatsächliche Gewicht vs. Volumengewicht, wählen Sie wirtschaftlichere Versandmethoden, gruppieren Sie Bestellungen und prüfen Sie aktuelle Aktionen auf der Hauptwebsite.',
  },
];